import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import "./informes.scss"
import {history} from "../../../_helpers";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {useLocation} from "react-router-dom";
import {xcService} from "../../../_services/xcService";
import InformeCeibaPDF from "./ceiba.pdf.page"

import {isBrowser} from 'react-device-detect';


// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require("lodash");

function InformeCeibaSimple(props) {

    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {query, search} = useLocation();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState(null);
    const [studentArea, setStudentArea] = useState();
    const [studentAreaCervo, setStudentAreaCervo] = useState();
    const [questionnaires, setQuestionnaires] = useState([]);
    const [userQuest, setUserQuest] = useState();
    const [code, setCode] = useState(null);
    const [course, setCourse] = useState();
    const [answersNoGame3, setAnswersNoGame3] = useState(null);
    const [answersCervo, setAnswersCervo] = useState(null);
    const [answersTek, setAnswersTek] = useState(null);
    const [studentHistory, setStudentHistory] = useState();
    const [allLoaded, setAllLoaded] = useState(false)
    const year = +new URLSearchParams(search).get('year');

    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'itin1',
            '4º ESO': 'itin2',
            '1º Bachillerato': 'itin3',
            '2º Bachillerato': 'itin4',
            'FP Grado Básico': 'itin2',
            'FP Grado Medio': 'itin4',
        }
        setUserQuest(quests[course])
    }

    const codes = {
        '3º ESO': 'TEK3ESO',
        '4º ESO': 'TEK4ESO',
        '1º Bachillerato': 'TEK1BAC',
        '2º Bachillerato': 'TEK2BAC',
        'FP Grado Básico': 'TEKFPB',
        'FP Grado Medio': 'TEKFPM',
    }

    const items1 = {
        '3º ESO': 4,
        '4º ESO': year < 23 ? 6 : 7,
        '1º Bachillerato': 7,
        '2º Bachillerato': 7,
        'FP Grado Básico': 5,
        'FP Grado Medio': 5,
    }

    const items2 = {
        '3º ESO': year < 23 ? 14 : 15,
        '4º ESO': year < 23 ? 13 : 14,
        '1º Bachillerato': 12,
        '2º Bachillerato': 10,
        'FP Grado Básico': 11,
        'FP Grado Medio': 10,
    }
    const items3 = {
        '3º ESO': 8,
        '4º ESO': year < 23 ? 7 : 8,
        '1º Bachillerato': 10,
        '2º Bachillerato': 8,
        'FP Grado Básico': 6,
        'FP Grado Medio': 8,
    }
    var getStudentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

    useEffect(() => {

        const mUrl = userType === 'STUDENT' ? `/v1/student/course?year=${year}` : `/v1/student/course/${studentUid}?year=${year}`;

        xcService.getToken(mUrl)
            .then(({data}) => {
                setQuest(data.data.name)
                setCourse(data.data.name)
                return data.data.name
            }).then(course => {

                setCode(codes[course])
            }
        );
    }, [])


    const getHistory = () => {
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;
                    if (mStudentProfile && data.data.course) {
                        mStudentProfile.course.id = data.data.course.id;
                        mStudentProfile.course.name = data.data.course.name;
                        setStudentProfile(mStudentProfile);
                    }
                })

        }
    }

    useEffect(() => {
        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            })
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            });

        }
    }, [studentUid]);


    const getAll = async () => {

        const questionPath = userType === 'STUDENT' ? `/v1/student/myquestionnaires?year=${year}` : `/v1/student/${studentUid}/questionnaires?year=${year}`;
        xcService.getToken(questionPath).then(async ({data}) => {
            setQuestionnaires(data.data)
            let mNoGame3 = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM3';
                }
            );
            if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/NOGAM3?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/NOGAM3?withResponses=true&year=${year}`;
                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame3(data.data));

            }

            let mCervo = _.filter(
                data.data, function (o) {
                    return o.code === 'CERVO';
                }
            );
            if (mCervo && mCervo[0] && mCervo[0].totresp === mCervo[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/CERVO?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/CERVO?withResponses=true&year=${year}`;

                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersCervo(data.data));
            }

            let mTek = _.filter(
                data.data, function (o) {
                    return o.code === code;
                }
            );
            if (mTek && mTek[0] && mTek[0].totresp === mTek[0].tota) {
                const mUrl = userType === 'STUDENT' ? `/v1/student/answers/${code}?withResponses=true&year=${year}` : `/v1/student/${studentUid}/answers/${code}?withResponses=true&year=${year}`;


                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersTek(data.data));
            }


            const answersPath = userType === 'STUDENT' ? `/v1/student/answers/CEIBA?year=${year}` : `/v1/student/${studentUid}/answers/CEIBA?year=${year}`;
            await  xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));
            const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
            await xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
            await xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));

            setAllLoaded(true);
        })

    }

    useEffect(() => {
        if (code )
        getAll()

    }, [code]);


    return (!studentProfile || !studentArea ? 'loading' :
        <div className={"container dasboard-informes"}>
            <div style={{
                    width: "100%", height: "100%"
            }}>

            <>
                { allLoaded && answers && answers.length > 0 && studentArea && studentProfile && studentArea &&
                    <InformeCeibaPDF
                        forDownload={isBrowser ? true : false} studentHistory={studentHistory}
                        props={props} studentProfile={studentProfile}
                                     answersNoGame3={answersNoGame3}
                                     answersCervo={answersCervo}
                                     answersTek={answersTek}
                                     items1={items1}
                                     items2={items2}
                        code={code}
                                     items3={items3}
                                     studentAreaCervo={studentAreaCervo}
                                     answers={answers}
                                     course={course}
                                     studentArea={studentArea}/>
                }


            </>
            </div>
        </div>
    )
}

export default withTranslation()(InformeCeibaSimple);


